import { render, staticRenderFns } from "./SUPACellPodEpic.vue?vue&type=template&id=70c159ae&scoped=true&"
import script from "./SUPACellPodEpic.vue?vue&type=script&lang=ts&"
export * from "./SUPACellPodEpic.vue?vue&type=script&lang=ts&"
import style0 from "./SUPACellPodEpic.vue?vue&type=style&index=0&id=70c159ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c159ae",
  null
  
)

export default component.exports